module.exports = __webpack_public_path__ + "static/media/eagle-eye-icon.95b89644.png";